import dayjs from "dayjs";
import { daysToSeconds, format } from "Shared/Utils/shared";
import { FORMAT_WITHOUT_TIME } from "Shared/Constants/app";

const today = new Date();
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
const firstDayOfLastMonth = new Date(
  today.getFullYear(),
  today.getMonth() - 1,
  1,
);
const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
const currentQuarter = Math.floor(today.getMonth() / 3);
const startOfThisQuarter = new Date(today.getFullYear(), currentQuarter * 3, 1);
const endOfThisQuarter = new Date(
  startOfThisQuarter.getFullYear(),
  startOfThisQuarter.getMonth() + 3,
  0,
);
const startOfLastQuarter = new Date(today.getFullYear(), 9, 1); // Q4 starts in October (9th month)
const endOfLastQuarter = new Date(today.getFullYear(), 12, 0);

export const quarterRanges = [
  {
    label: "Today",
    from: format(today, FORMAT_WITHOUT_TIME),
    to: format(today, FORMAT_WITHOUT_TIME),
  },
  {
    label: "Last 7 Days",
    from: format(dayjs().subtract(7, "day").toDate(), FORMAT_WITHOUT_TIME),
    to: format(today, FORMAT_WITHOUT_TIME),
  },
  {
    label: "Last 30 Days",
    from: format(dayjs().subtract(30, "day").toDate(), FORMAT_WITHOUT_TIME),
    to: format(today, FORMAT_WITHOUT_TIME),
  },
  {
    label: "This Month",
    from: format(firstDayOfMonth, FORMAT_WITHOUT_TIME),
    to: format(lastDayOfMonth, FORMAT_WITHOUT_TIME),
  },
  {
    label: "Last Month",
    from: format(firstDayOfLastMonth, FORMAT_WITHOUT_TIME),
    to: format(lastDayOfLastMonth, FORMAT_WITHOUT_TIME),
  },
  {
    label: "This Quarter",
    from: format(startOfThisQuarter, FORMAT_WITHOUT_TIME),
    to: format(endOfThisQuarter, FORMAT_WITHOUT_TIME),
  },
  {
    label: "Last Quarter",
    from: format(startOfLastQuarter, FORMAT_WITHOUT_TIME),
    to: format(endOfLastQuarter, FORMAT_WITHOUT_TIME),
  },
];
export const durationRanges = [
  {
    label: "1 Day",
    from: "0",
    to: daysToSeconds(1).toString(),
  },
  {
    label: "3 Days",
    from: "0",
    to: daysToSeconds(3).toString(),
  },
  {
    label: "5 Days",
    from: "0",
    to: daysToSeconds(5).toString(),
  },
  {
    label: "10 Days",
    from: "0",
    to: daysToSeconds(10).toString(),
  },
  {
    label: "15 Days",
    from: "0",
    to: daysToSeconds(15).toString(),
  },
  {
    label: "30 Days",

    from: "0",
    to: daysToSeconds(30).toString(),
  },
  {
    label: "45 Days",
    from: "0",
    to: daysToSeconds(45).toString(),
  },
];
